import React, { useCallback, useContext, useState } from "react";
import {
  makeStyles,
  createStyles,
  AppBar,
  Toolbar,
  IconButton,
  Badge,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

import Menu from "./Menu";
import ProgressBar from "./ProgressBar";
import { BadgeContext } from "../../containers/App";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    spacer: theme.mixins.toolbar,
    progress: {
      position: "absolute",
      width: "100%",
      bottom: 0,
    },
  })
);

const TopBar = React.memo((props) => {
  const { isLoading = false, children } = props;
  const classes = useStyles();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isShowBadge } = useContext(BadgeContext);

  const handleClickMenuIcon = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
  }, []);

  const toggleMenu = useCallback((isOpen) => {
    setIsMenuOpen(isOpen);
  }, []);

  return (
    <>
      <AppBar>
        <Toolbar className={classes.root}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClickMenuIcon}
            size="small"
          >
            <Badge
              variant="dot"
              color="secondary"
              invisible={!isShowBadge}
              overlap="circle"
            >
              <MenuIcon />
            </Badge>
          </IconButton>

          {/* 子要素のアイコンボタンが入る想定 */}
          {children}
        </Toolbar>

        <ProgressBar isLoading={isLoading} className={classes.progress} />
      </AppBar>

      <div className={classes.spacer} />

      <Menu
        open={isMenuOpen}
        onClose={() => toggleMenu(false)}
        onOpen={() => toggleMenu(true)}
      />
    </>
  );
});

export default TopBar;
